import { IEdgeServers } from '../../../../core/api/dto/BuffetDishDto'
import { setEdgeServers } from '../../../../shared/lib/setEdgeServers'
import {
  useDeletePlanMenuToFotoboxesMutation,
  useSendPlanMenuToFotoboxesMutation,
} from '../../../../core/api/PlanMenuApi'
import { useEffect, useState } from 'react'

export const useUpdatePlanMenuStations = (
  oldValue: IEdgeServers[],
  newValue: IEdgeServers[],
) => {
  const [value, setValue] = useState<IEdgeServers[]>([])
  const { deletedItems, addedItems } = setEdgeServers(value, newValue) || {}

  useEffect(() => {
    if (!value.length && oldValue.length) {
      setValue(oldValue)
    }
    // eslint-disable-next-line
  }, [oldValue])

  const [sendPlanMenuToFotoboxes] = useSendPlanMenuToFotoboxesMutation()
  const [deletePlanMenuToFotoboxes] = useDeletePlanMenuToFotoboxesMutation()
  const onUpdateStation = (planMenuGuids: string) => {
    if (
      deletedItems?.length &&
      process.env.REACT_APP_TYPE_SERVER === 'MainServer'
    ) {
      deletePlanMenuToFotoboxes({
        planMenusGuids: [planMenuGuids],
        edgeServersGuids: deletedItems,
      })
    }
    if (
      addedItems?.length &&
      process.env.REACT_APP_TYPE_SERVER === 'MainServer'
    ) {
      sendPlanMenuToFotoboxes({
        planMenusGuids: [planMenuGuids],
        edgeServersGuids: addedItems,
      })
    }
  }
  return { onUpdateStation }
}
